import instObj from '@/backend/axios-instances'

const resource = "/cutsheets/assemblies"
const instance = instObj.baseInstance

export default {
  post(data, parameters) {
    //need assemblysheet_id as a param
    return instance.post(`${resource}/details`, data, { params: parameters });
  },
  get(parameters) {
    return instance.get(`${resource}/details`, { params: parameters });
  },
  put(detailId, data, parameters) {
    return instance.put(`${resource}/detail/${detailId}`, data, { params: parameters });
  },
  delete(detailId, parameters) {
    return instance.delete(`${resource}/detail/${detailId}`, { params: parameters });
  }
}